import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Button, Text } from '@flexisaf/flexibull2';
import { useSelector } from 'react-redux';
import TemplateEngine from 'components/templates-engine';
import CanView, { Permissions } from 'components/CanView';
import Thumbnail from 'assets/images/thumbnail.png';
import Theme from 'utils/theme';
import { formattedTemplateDataForEdit } from 'components/templates-engine/formatTemplateData';
import { selectInstitution } from 'redux/configurations/selectors';
import { useRouteMatch } from 'react-router-dom';

const TemplateViewer = ({ templates }) => {
  const organisation = useSelector(selectInstitution);
  const { params } = useRouteMatch();

  const editUserTemplate = (templateData) => {
    const formattedTemplateData = formattedTemplateDataForEdit(
      templateData,
      organisation
    );
    sessionStorage.setItem(
      'template',
      JSON.stringify({ templateData: formattedTemplateData, mode: 'edit' })
    );
    window.open(`/${params.orgName}/manage-template`, '_blank');
  };

  return (
    <TemplateEngine>
      <Box margin="25px 0px">
        <Grid
          lr="repeat(6, 1fr)"
          default="repeat(2, 1fr)"
          md="1fr 1fr"
          sm="1fr"
        >
          {templates?.map((template) => (
            <Box className="thumbnail-wrapper" key={template.name}>
              <Box className="template-name">
                <Text block capitalize>
                  {template?.type} Template
                </Text>
              </Box>
              <div className="thumbnail-selector">
                <Box className="thumbnail-container">
                  <img src={Thumbnail} alt="" />
                  <Box className="thumbail-des" pad="20px 10px" vAlign>
                    <Text
                      block
                      bold
                      style={{
                        marginBottom: '10px',
                        cursor: 'pointer',
                      }}
                      onClick={() => editUserTemplate(template)}
                    >
                      {template.name}
                    </Text>
                    <CanView can={[Permissions.UPDATE_TEMPLATE]}>
                      <Button
                        uppercase
                        pale
                        height={30}
                        spaceTop
                        color={Theme.PrimaryGreen}
                        fontColor={Theme.PrimaryGreen}
                        onClick={() => editUserTemplate(template)}
                      >
                        Preview Template
                      </Button>
                    </CanView>
                  </Box>
                </Box>
              </div>
            </Box>
          ))}
        </Grid>
      </Box>
    </TemplateEngine>
  );
};

TemplateViewer.propTypes = {
  templates: PropTypes.array,
};

export default TemplateViewer;
